import { useState } from 'react'
import IndustryDropdown from '@/components/molecules/IndustryDropdown'
import SiteButton from '@/components/atoms/SiteButton'
import { INDUSTRIES } from './industries'

export function IndustryPickerSection() {
    const [selectedKey, setSelectedKey] = useState(INDUSTRIES[0].key)
    const selected = INDUSTRIES.find((i) => i.key === selectedKey) ?? INDUSTRIES[0]

    return (
        <section className="bg-unimo-stone pt-section-gap">
            <div className="relative isolate min-h-[620px] overflow-hidden rounded-site-panel md:min-h-0">
                {/* Mobile illustration is cropped tight to the buildings with no
                    clearance at the top, but has a plain "ground" zone at the
                    bottom — so the copy anchors to the bottom of the panel on
                    mobile, and to the top-left on desktop where the full-bleed
                    illustration has a clear gradient-sky area for it. */}
                <img
                    src={selected.illustration.mobile}
                    alt=""
                    aria-hidden="true"
                    className="absolute inset-0 h-full w-full object-cover object-top md:hidden"
                />
                <img
                    src={selected.illustration.desktop}
                    alt=""
                    aria-hidden="true"
                    className="absolute inset-0 hidden h-full w-full object-cover md:block"
                />

                <div className="relative flex h-full min-h-[620px] flex-col justify-end p-6 md:aspect-[1281/528] md:min-h-0 md:justify-start lg:p-16">
                    <div className="flex flex-col gap-1 text-lg font-medium leading-tight text-unimo-slate lg:text-4xl">
                        <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1">
                            <span>What</span>
                            <IndustryDropdown
                                id="homepage-industry-picker"
                                industries={INDUSTRIES.map(({ key, pickerLabel }) => ({ key, label: pickerLabel }))}
                                selectedKey={selectedKey}
                                onSelect={setSelectedKey}
                            />
                        </div>
                        <span>love about unimo.</span>
                    </div>

                    <p className="mt-2 max-w-xl text-lg font-light text-unimo-slate lg:mt-6 lg:text-xl">
                        {selected.subheadline}
                    </p>

                    <SiteButton href={`/industries/${selected.key}`} className="mt-8 w-fit">
                        {selected.cta}
                    </SiteButton>
                </div>
            </div>
        </section>
    )
}

export default IndustryPickerSection
